import React from "react";
import { motion } from "framer-motion";
import { useSiteContent, resolveImage } from "@/context/SiteContentContext";

export default function AboutIsiGroup() {
  const content = useSiteContent();
  const g = content?.isi_group;
  const ach = content?.achievements || [];
  if (!g) return null;

  return (
    <section
      id="isigroup"
      data-testid="isigroup-section"
      className="relative py-24 lg:py-36 bg-slate-900 text-white overflow-hidden"
    >
      <div className="absolute inset-0 -z-0">
        {g.background_image && (
          <img src={resolveImage(g.background_image)} alt="" className="w-full h-full object-cover opacity-25" />
        )}
        <div className="absolute inset-0 bg-gradient-to-b from-slate-900/80 via-slate-900/70 to-slate-900" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-end mb-16">
          <div className="lg:col-span-8">
            <div className="flex items-center gap-3 mb-5">
              <span className="h-px w-12 bg-orange-500" />
              <span className="text-xs tracking-[0.25em] uppercase text-sky-300 font-display">
                {content?.sections?.isigroup_label || "iSi Group · Our Story"}
              </span>
            </div>
            <h2 className="font-serif-sc text-4xl lg:text-5xl xl:text-7xl font-bold leading-[1.05] tracking-tight">
              {g.heading_top}<br />
              <span className="text-orange-500">{g.heading_bottom}</span>
            </h2>
          </div>
          <div className="lg:col-span-4">
            <p className="text-slate-300 leading-relaxed text-base">{g.description}</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10">
          {g.pillars?.map((p, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              data-testid={`pillar-${p.num}`}
              className="bg-slate-900 p-8 lg:p-10 group hover:bg-slate-800 transition-colors duration-500"
            >
              <div className="font-display text-5xl lg:text-6xl text-orange-500 tracking-tighter font-bold">
                {p.num}
              </div>
              <h3 className="font-serif-sc text-2xl mt-6 text-white">{p.title}</h3>
              <p className="mt-4 text-sm text-slate-400 leading-relaxed">{p.text}</p>
              <div className="mt-8 h-px w-0 bg-orange-500 group-hover:w-full transition-all duration-700" />
            </motion.div>
          ))}
        </div>

        <div className="mt-16 grid grid-cols-2 lg:grid-cols-4 gap-6">
          {ach.map((s) => (
            <div key={s.key} className="border-t border-white/15 pt-6">
              <div className="font-display font-bold text-3xl lg:text-4xl text-white tracking-tighter">
                {s.value}
              </div>
              <div className="text-xs tracking-[0.25em] uppercase text-sky-300/80 font-display mt-2">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
